module.exports = __webpack_public_path__ + "img/US-Virgin-Islands.8894ec36.png";